<template lang="pug">
select(v-model="environment", :disabled="disabled")
  option(v-for="environment in environments", :value="environment") {{ environment }}
</template>

<script>
export default {
    props: {
        initial: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
        },
        wildcard: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        environment: "prod",
    }),

    computed: {
        environments() {
            const environments = ["prod", "steam", "steam-demo"];
            if (this.wildcard) {
                return ["*", ...environments];
            }
            return environments;
        },
    },
    mounted() {
        this.environment = "prod";
        this.$emit("change", this.environment);
    },

    watch: {
        environment() {
            this.$emit("change", this.environment);
        },
    },
};
</script>
